import { useMutation } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import Auth, { type LoginResponse } from 'src/services/api/auth/Auth';

type ApiResponse = LoginResponse;
type Response = ApiResponse;

type Request = {
  email: string;
  password: string;
}

export const useLogin = (saveTokens = true) => {
    return useMutation<Response, IStandardErrorResponse, Request>(
        (payload) => Auth.login(payload.email, payload.password, saveTokens)
    );
};
